export default __webpack_public_path__ + "images/759f69873f707c14793eb7baa0e56a32-something-dope-for-the-people.svg";